import { IVendorAdapter } from './IVendorAdapter';
import { ApiResponse } from '../../types/api';
import { Vendor, AMCContract, CreateVendorDto, CreateAMCContractDto, VendorFilter } from '../../types/vendor';
import { ApiClient as apiClient } from '../apiClient';

export class LaravelVendorAdapter implements IVendorAdapter {
  private readonly BASE = '/api/vendors';
  private readonly CONTRACT_BASE = '/api/amc-contracts';

  async getVendors(filter?: VendorFilter): Promise<ApiResponse<Vendor[]>> {
    const params = new URLSearchParams();
    if (filter?.status) params.set('status', filter.status);
    if (filter?.category_id) params.set('category_id', filter.category_id);
    if (filter?.location_id) params.set('location_id', filter.location_id);
    if (filter?.search) params.set('search', filter.search);
    return apiClient.get<Vendor[]>(`${this.BASE}?${params.toString()}`);
  }

  async getVendorById(id: string): Promise<ApiResponse<Vendor>> {
    return apiClient.get<Vendor>(`${this.BASE}/${id}`);
  }

  async createVendor(dto: CreateVendorDto): Promise<ApiResponse<Vendor>> {
    return apiClient.post<Vendor>(this.BASE, dto);
  }

  async updateVendor(id: string, dto: Partial<CreateVendorDto>): Promise<ApiResponse<Vendor>> {
    return apiClient.put<Vendor>(`${this.BASE}/${id}`, dto);
  }

  async updateVendorStatus(id: string, status: Vendor['status']): Promise<ApiResponse<Vendor>> {
    return apiClient.patch<Vendor>(`${this.BASE}/${id}/status`, { status });
  }

  async getContracts(vendorId?: string): Promise<ApiResponse<AMCContract[]>> {
    const params = vendorId ? `?vendor_id=${vendorId}` : '';
    return apiClient.get<AMCContract[]>(`${this.CONTRACT_BASE}${params}`);
  }

  async getContractById(id: string): Promise<ApiResponse<AMCContract>> {
    return apiClient.get<AMCContract>(`${this.CONTRACT_BASE}/${id}`);
  }

  async createContract(dto: CreateAMCContractDto): Promise<ApiResponse<AMCContract>> {
    return apiClient.post<AMCContract>(this.CONTRACT_BASE, dto);
  }

  async updateContractStatus(id: string, status: AMCContract['status']): Promise<ApiResponse<AMCContract>> {
    return apiClient.patch<AMCContract>(`${this.CONTRACT_BASE}/${id}/status`, { status });
  }
}
